import { PickType } from '@nestjs/swagger';
import { SpSubdivisionNameMapableInterface } from '../interfaces/sp-subdivision-name-mapable.interface';
import { SpSubdivisionNameDto } from './sp-subdivision-name.dto';

export class SpSubdivisionNameMapableDto
  extends PickType(SpSubdivisionNameDto, ['subdivisionId'])
  implements SpSubdivisionNameMapableInterface {}
